module.exports = __webpack_public_path__ + "img/markerBusOrange.679b4da8.svg";